import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { fetchHtml } from '@app/util/fetchHTML';
import i18n from '@common/config/i18n';

import infoClases from './InfoView.module.scss';

const validRoutes = ['credits'];

export default function InfoView() {
  const params = useParams();
  const [content, setContent] = useState('');

  useEffect(() => {
    const handleLanguageChanged = (lng) => {
      const isValid = validRoutes.indexOf(params.route) > -1;
      if (isValid) {
        fetchHtml(
          `/locales/${lng}/html/${params.route}.html`,
          (html) => setContent(html),
          () => {
            setContent('NOT FOUND');
          },
        );
      } else {
        setContent('NOT FOUND');
      }
    };

    handleLanguageChanged(i18n.language);

    i18n.on('languageChanged', handleLanguageChanged);
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n.language, params.route]);

  return (
    <div
      className={infoClases.styles}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
